import React from "react";
import { Avatar } from "../../components"; // adjust path based on your project

const InfoViewCard = ({
  title,          // e.g. "Abhi Y"
  subtitle,       // e.g. "Confidential"
  description,    // e.g. "Abhi Y viewed confidential information on ..."
  timestamp,      // e.g. "04/04/2025 13:01:39"
}) => {
  return (
    <div className="border-[1px] border-neutrals-50 rounded px-4 py-3 flex justify-between items-center">
      <div className="flex gap-3">
        <Avatar size="xl" />
        <div>
          <div className="flex items-center gap-4">
            <p className="font-medium ">{title}</p>
            {subtitle && (
              <span className="body-two text-neutral-400">{subtitle}</span>
            )}
          </div>
          <div className="text-sm text-black"> {title} {description} {timestamp}</div>
        </div>
      </div>
      <div className="body-two text-neutrals-400">{timestamp}</div>
    </div>
  );
};

export default InfoViewCard;
